import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { CheckCircle as CheckIcon, CancelOutlined as MissingIcon } from '@mui/icons-material';
import { navigate } from '../lib/navigation';
import { requiredProfileItems } from '../lib/profileReadiness';
import Button from './Button';

function PublishProfileDialog({ open, creator, onClose, onPublish }) {
  const items = requiredProfileItems(creator);
  const missing = items.filter((item) => !item.complete);
  const ready = missing.length === 0;
  const goToField = (path) => {
    const targetID = path.split('#')[1];
    navigate(path);
    if (targetID) setTimeout(() => document.getElementById(targetID)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{ready ? 'Ready to publish' : 'Finish your profile first'}</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          {ready
            ? 'Your profile meets the publishing requirements. Optional sections can be completed now or after you go live.'
            : 'Complete these essentials before your profile can go live.'}
        </Typography>
        <Stack spacing={1}>
          {items.map((item) => (
            <Stack key={item.key} direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
              {item.complete ? <CheckIcon color="success" /> : <MissingIcon color="error" />}
              <Typography sx={{ flexGrow: 1 }}>{item.label}</Typography>
              {!item.complete && (
                <Button
                  variant="secondary"
                  size="small"
                  onClick={() => {
                    onClose();
                    goToField(item.path);
                  }}
                >
                  Fix
                </Button>
              )}
            </Stack>
          ))}
        </Stack>
        {ready && (
          <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(78, 40, 181, 0.06)' }}>
            <Typography variant="body2">
              Adding social stats, content samples, and brand history will make your profile more useful to brands.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="ghost" onClick={onClose}>{ready ? 'Not yet' : 'Close'}</Button>
        {ready && <Button onClick={onPublish}>Publish profile</Button>}
      </DialogActions>
    </Dialog>
  );
}

export default PublishProfileDialog;
